module.exports = __webpack_public_path__ + "static/media/gt-walsheim-medium.883123dc.ttf";